// ============================================================
// 开机启动序列：JKDY/OS 引导动画（可点击/按键跳过）
// ============================================================

const BOOT_LINES = [
  { text: "JKDY/OS v2.6.6 — 极客导演创意系统", cls: "dim" },
  { text: "> 挂载神经网络渲染器 .......... OK", cls: "ok" },
  { text: "> 启动 GPU 集群 (8× RTX 模拟) .. OK", cls: "ok" },
  { text: "> 解码 imagination 模块 ........ OK", cls: "ok" },
  { text: "> 注入创作基因 ................ OK", cls: "ok" },
  { text: "> ACCESS GRANTED — 欢迎回来，导演", cls: "ok" },
];

const BOOT_MS = 1500; // 默认启动时长

export default function initBoot() {
  const overlay = document.getElementById("boot");
  if (!overlay) return;

  const linesEl = document.getElementById("boot-lines");
  const barEl = document.getElementById("boot-progress-bar");
  let finished = false;

  const finish = () => {
    if (finished) return;
    finished = true;
    overlay.classList.add("is-done");
    window.dispatchEvent(new CustomEvent("jk:booted"));
    // 过渡结束后移出 DOM，避免遮挡交互
    setTimeout(() => overlay.remove(), 600);
    document.removeEventListener("keydown", skip);
    overlay.removeEventListener("click", skip);
  };

  const skip = () => finish();

  document.addEventListener("keydown", skip);
  overlay.addEventListener("click", skip);

  // 逐行输出
  let i = 0;
  const typeLine = () => {
    if (finished || i >= BOOT_LINES.length) return;
    const line = BOOT_LINES[i];
    const p = document.createElement("p");
    p.className = line.cls;
    p.textContent = line.text;
    linesEl.appendChild(p);
    i += 1;
    setTimeout(typeLine, 170);
  };
  typeLine();

  // 进度条
  const startAt = performance.now();
  const tick = (now) => {
    if (finished) return;
    const p = Math.min((now - startAt) / BOOT_MS, 1);
    barEl.style.width = `${Math.round(p * 100)}%`;
    if (p < 1) {
      requestAnimationFrame(tick);
    } else {
      finish();
    }
  };
  requestAnimationFrame(tick);

  // 兜底：任何环境下（含 rAF 被限制的无头渲染）都能按时完成启动
  setTimeout(finish, BOOT_MS + 600);
}
